import React from "react";
import { Button } from "semantic-ui-react";
import { useDispatch } from "react-redux";
import { ModalBuilder } from "@redriver/cinnamon";
import { TranslatedModal } from "features/../../../shared/components/modals";
import { useTranslation } from "react-i18next";
import { downloadDocumentPack } from "../actions";

const DownloadDocuments = ({
  sheetId,
  clientName,
  crmCompanyId,
  disableTrigger,
  disableSubmit,
  onSubmitted,
  renderTrigger,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation("sheetSummary", {
    keyPrefix: "DownloadDocumentsModal",
  });
  const { t: ddn } = useTranslation("downloadDocumentNames");
  return (
    <ModalBuilder
      onSubmit={() => {
        dispatch(downloadDocumentPack(sheetId, crmCompanyId, clientName, ddn));
      }}
      onSubmitted={onSubmitted}
      renderTrigger={
        renderTrigger ||
        ((onRender) => (
          <Button
            primary
            compact
            icon="download"
            disabled={disableTrigger}
            onClick={onRender}
            content={t("Trigger")}
          />
        ))
      }
      renderModal={(modalProps, data, state) => (
        <TranslatedModal.Confirmation
          {...modalProps}
          header={t("Header")}
          submitDisabled={state.loading || state.error || disableSubmit}
        >
          {t("ConfirmMessage")}
        </TranslatedModal.Confirmation>
      )}
    />
  );
};

export default DownloadDocuments;
